"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBusinessRequestToJSON = exports.UpdateBusinessRequestFromJSONTyped = exports.UpdateBusinessRequestFromJSON = exports.instanceOfUpdateBusinessRequest = void 0;
/**
 * Check if a given object implements the UpdateBusinessRequest interface.
 */
function instanceOfUpdateBusinessRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfUpdateBusinessRequest = instanceOfUpdateBusinessRequest;
function UpdateBusinessRequestFromJSON(json) {
    return UpdateBusinessRequestFromJSONTyped(json, false);
}
exports.UpdateBusinessRequestFromJSON = UpdateBusinessRequestFromJSON;
function UpdateBusinessRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
exports.UpdateBusinessRequestFromJSONTyped = UpdateBusinessRequestFromJSONTyped;
function UpdateBusinessRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
    };
}
exports.UpdateBusinessRequestToJSON = UpdateBusinessRequestToJSON;
